import React, { useEffect, useState } from "react";
import "../../../../pages/D05_Response_Distribution.css"; // Ensure this path matches your project structure

const WorkContextDistributionTable = ({ data, filterCriteria = {} }) => {
  const [filteredData, setFilteredData] = useState(data);

  useEffect(() => {
    const applyFilterCriteria = (data, filterCriteria) => {
      return data.filter((item) => {
        return Object.keys(filterCriteria).every((key) => {
          const isCriteriaEmpty =
            !filterCriteria[key] || filterCriteria[key].length === 0;
          const doesItemMatchCriteria = filterCriteria[key]?.includes(
            item[key]
          );
          return isCriteriaEmpty || doesItemMatchCriteria;
        });
      });
    };

    const newFilteredData = applyFilterCriteria(data, filterCriteria);
    setFilteredData(newFilteredData);
  }, [data, filterCriteria]);

  console.log("Filtered Data:", filteredData);

  if (
    !filteredData ||
    !Array.isArray(filteredData) ||
    filteredData.length === 0
  ) {
    return <div>No data available</div>;
  }

  console.log("Sample filtered data items:", filteredData.slice(0, 5));

  // Define key mappings for Work Context engagement areas
  const keyMappings = {
    "Communication": ["MQ0194", "MQ0321", "MQ0058"],
    "Compensation ": ["MQ0088", "MQ0090", "MQ0091"],
    "Leadership  ": ["MQ0086", "MQ0034", "MQ0041"],
    "Safety        ": ["MQ0190", "MQ0141", "MQ0343"],
    "Supervision   ": ["MQ0056", "MQ0057", "MQ0038"],
  };

  // Function to calculate percentage
  const calculatePercentage = (value, total) => {
    return ((value / total) * 100).toFixed(1);
  };

  // Function to calculate response distribution for each group
  const calculateResponseDistribution = (group) => {
    const keys = keyMappings[group];
    if (!keys) return { NR: 0, 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };

    const responses = filteredData.flatMap((item) =>
      keys.map((key) => item[key])
    );

    console.log(`Responses for ${group}:`, responses);

    const distribution = {
      NR: 0,
      1: 0,
      2: 0,
      3: 0,
      4: 0,
      5: 0,
    };

    let validResponses = 0;

    responses.forEach((response) => {
      if (response === null) {
        distribution.NR++;
      } else if (response >= 1 && response <= 5) {
        distribution[response]++;
        validResponses++;
      }
    });

    const distributionPercentage = {
      NR: calculatePercentage(distribution.NR, responses.length),
      1: calculatePercentage(distribution[1], validResponses),
      2: calculatePercentage(distribution[2], validResponses),
      3: calculatePercentage(distribution[3], validResponses),
      4: calculatePercentage(distribution[4], validResponses),
      5: calculatePercentage(distribution[5], validResponses),
    };

    console.log(`Distribution for ${group}:`, distribution);
    console.log(
      `Distribution Percentage for ${group}:`,
      distributionPercentage
    );

    return distributionPercentage;
  };

  return (
    <div className="D05_Response_Distribution-table">
      <div className="table-header">
        <div className="table-column">Area</div>
        <div className="table-column">NR</div>
        <div className="table-column">1</div>
        <div className="table-column">2</div>
        <div className="table-column">3</div>
        <div className="table-column">4</div>
        <div className="table-column">5</div>
      </div>
      {Object.keys(keyMappings).map((group) => (
        <div className="table-row" key={group}>
          <div className="table-column">{group}</div>
          <div className="table-column">
            {calculateResponseDistribution(group).NR}%
          </div>
          <div className="table-column">
            {calculateResponseDistribution(group)[1]}%
          </div>
          <div className="table-column">
            {calculateResponseDistribution(group)[2]}%
          </div>
          <div className="table-column">
            {calculateResponseDistribution(group)[3]}%
          </div>
          <div className="table-column">
            {calculateResponseDistribution(group)[4]}%
          </div>
          <div className="table-column">
            {calculateResponseDistribution(group)[5]}%
          </div>
        </div>
      ))}
    </div>
  );
};

export default WorkContextDistributionTable;
